import { type ReactNode } from 'react';
import { type FieldError } from 'react-hook-form';
import { cn } from '@bedrock/ui/utils';
import { ErrorMessage } from './error-message';

type FormFieldProps = Readonly<{
  label: string;
  error?: FieldError;
  children: ReactNode;
  className?: string;
}>;

export function FormField({ label, error, children, className }: FormFieldProps) {
  return (
    <label className={cn('mt-px flex min-w-0 flex-1 flex-col', className)}>
      <span className="sr-only">{label}</span>
      {children}
      <ErrorMessage error={error} />
    </label>
  );
}
